import styled from 'styled-components';

export const TotalRowTd = styled.td`
    border-top: none !important;
`;
